import { CloseOutlined } from '@ant-design/icons';
import { FlameIcon } from '@assets/icons/flame';
import PowerDefinitionImage from '@assets/images/power-definition-mobile.png';
import { EmptyButton } from '@atoms';
import { Modal } from '@models';

import { env } from 'src/app/env';

import VideoPlayer from '../../../organisms/VideoPlayer/VideoPlayer.organism';
import * as T from './common.styles';
import * as S from './DefaultMobile.style';

interface DefaultMobileProps {
  onClose: () => void;
  modalInfo?: Modal.IModal;
}

const DEFAULT_TITLE = 'Tá na hora da sua aula de Power Abs!';
const DEFAULT_DESCRIPTION =
  'Você vai queimar a gordura por até 48h depois do fim do treino, trabalhando os 4 músculos do abdômen. Tudo isso, para deixar a sua cintura marcada para o verão que está chegando.';
const DEFAULT_BUTTON_LABEL = 'Treinar Agora';

export const DefaultMobile = ({ onClose, modalInfo }: DefaultMobileProps) => {
  const imageSrc = !!modalInfo?.advertisements[0].webImageFileId
    ? `${env.FILE_API}/files/files/view/${modalInfo?.advertisements[0].mobileImageFileId}`
    : PowerDefinitionImage;

  return (
    <T.Container isMobile>
      <T.Header>
        <FlameIcon />
        <EmptyButton onClick={() => onClose()}>
          <CloseOutlined style={{ color: '#000', fontSize: '20px' }} />
        </EmptyButton>
      </T.Header>

      <S.Body>
        <T.Content>
          <S.Title>
            {modalInfo?.advertisements[0].title || DEFAULT_TITLE}
          </S.Title>
          <S.Description>
            {modalInfo?.advertisements[0].description || DEFAULT_DESCRIPTION}
          </S.Description>

          {!modalInfo?.advertisements[0].videoLink && (
            <S.CustomImage preview={false} src={imageSrc} />
          )}

          {!!modalInfo?.advertisements[0].videoLink && (
            <VideoPlayer
              url={modalInfo?.advertisements[0].videoLink}
              height='320px'
            />
          )}
        </T.Content>

        <T.Footer isMobile>
          <T.CustomCheckbox onChange={() => null}>
            Não mostrar este conteúdo novamente
          </T.CustomCheckbox>

          {!!modalInfo && !!modalInfo.advertisements[0].buttonLabel && (
            <T.CustomButton isMobile>
              {modalInfo?.advertisements[0].buttonLabel}
            </T.CustomButton>
          )}

          {!modalInfo && (
            <T.CustomButton isMobile>{DEFAULT_BUTTON_LABEL}</T.CustomButton>
          )}
        </T.Footer>
      </S.Body>
    </T.Container>
  );
};
